import { ArrowForward, Article } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { CurrencyFormField } from "./CurrencyFormField";

export const CurrencyInfo = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Article style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Information")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <CurrencyFormField label={t("Code")} type="text" code="Code" data={dataState} setData={setDataState} />
            <CurrencyFormField label={t("Name")} type="text" code="Name" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}